import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function companiesAttributesRequest(urlParams = {}) {
  return request({
    method: 'get',
    url: urlParams.page ? urls.companiesListPaginated : urls.companiesAttributes,
    urlParams,
    headers: getHeaders(),
  });
}

export async function companiesListRequest(urlParams) {
  return request({
    method: 'get',
    url: urls.companiesList,
    urlParams,
    headers: getHeaders(),
  });
}

export async function companyDetailRequest(urlParams) {
  return request({
    method: 'get',
    url: urls.companyDetail,
    urlParams,
    headers: getHeaders(),
  });
}

export async function searchCompanyByNameRequest({ projectId, query }, requestConfig = {}) {
  return request({
    method: 'get',
    url: `/projects/${projectId}/companies?company_name=*${query}*`,
    headers: getHeaders(),
    ...requestConfig,
  });
}

export async function companyUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.companyUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function companyCreateRequest(urlParams, data) {
  return request({
    method: 'post',
    url: urls.companyCreate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function companyRemoveRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.companyDelete,
    urlParams,
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/companies.js